import '../Body.css';
import React from "react";
import windowAccent from '../../assets/images/windowAccent.png';

function Curriculum(props) {

    return (
        <div className="curriculum">
            <p className="subPageHeader"> SUMMER SERIES </p>
            <div className="divRow">
                <p className="sessionDates"> session 1: June 23rd - August 1st </p>
                <p className="sessionDates"> session 2: July 7th - August 15th</p>
                <p className="sessionDates"> session 3: July 21st - August 29th</p>
            </div>
            <p className="subPageBodyText centeredTextSmall"> FTFAA's summer learning series focuses on building fundamental web development skills - working in Javascript and Python </p>
            <img className="windowAccentCurriculum" src={windowAccent} alt="old school pop up window with a bright yellow drop shadow" />
            <p className="windowAccentHeader"> 6 week program, running monday-friday</p>
            <p className="subPageBodyText windowAccentText"> consisting of:</p>
            <p className="subPageBodyText windowAccentText"> -1 hour daily lecture</p>
            <p className="subPageBodyText windowAccentText"> -30 minute daily small group lab</p>
            <p className="subPageBodyText windowAccentText"> -weekly project based homework assignment</p>
            <p className="subPageBodyText windowAccentText"> -weekly guest speakers</p>
            <p className="subPageBodyText windowAccentText"> -access to exclusive course templates</p>
            <div className="windowEmptySpace"></div>
            <p className="subPageBodyText centeredTextSmall"> At the end of the program, all students have the opportunity to pitch their final projects to a panel of investors, gaining valuable feedback from industry professionals and hands-on experience presenting in a real-world setting. The top pitch will receive a $20,000 investment from Cerise Technology, with additional prizes awarded to the top 10 pitches. </p>
            <p className="subPageHeader"> WINTER SERIES </p>
            <p className="subPageBodyText centeredTextSmall"> more info coming soon! </p>
        </div>
    )
}

export default Curriculum;